import PropTypes from 'prop-types';
import { Empty, Button } from 'antd';
import { fromAppVar } from 'graphql/cache';
import Path from 'routes/path';

import './InvalidConnection.scss';

const InvalidConnection = ({ description }) => {
  const appVar = fromAppVar();

  const reconnectToProspero = async () => {
    window.open(Path.INTEGRATION, '_blank');
  };

  const fallbackDescription = (
    <div className="invalid-connection-message">
      <span className="invalid-connection-message-text">
        This {appVar || 'monday'} account is no longer connected to Prospero.
        <br />
        Please log in to your Prospero account and reconnect the integration from the Integrations
        page.
        <br />
        <br />
        <Button
          type="primary"
          htmlType="submit"
          block
          className="login-btn large-btn"
          tabIndex={4}
          onClick={reconnectToProspero}>
          <span className="btn-text">Reconnect in Prospero</span>
        </Button>
        <span className="plus-refresh-instruction">Please refresh the page after reconnecting</span>
      </span>
    </div>
  );

  return <Empty className="invalid-connection" description={description || fallbackDescription} />;
};

InvalidConnection.propTypes = {
  description: PropTypes.instanceOf(Object),
};

export default InvalidConnection;
